module.exports = __webpack_public_path__ + "img/2-5.aead11c8.svg";